<!-- @format -->

<ng-container *transloco="let t">
  <sis-checkbox
    [label]="t('TIMELINE.SHOW_SUMMER_PERIODS')"
    [checked]="isChecked$ | async"
    (checkedChange)="setShowSummerPeriod($event)"></sis-checkbox>
</ng-container>
